export default __webpack_public_path__ + "static/media/eat-scale.45eee627.png";